// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__BXUkX","colCheckbox":"styles_colCheckbox__qXR4h"};